import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/App";
import { UI, tr } from "@/i18n";

const Navbar = () => {
  const { lang, setLang } = useLang();
  const navigate = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-cream/80 border-b border-border">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-home" className="flex items-baseline gap-2 group">
          <span className="font-display text-xl sm:text-2xl tracking-tight text-navy">FORINONES <span className="text-gold">ONE MATCH™</span></span>
        </Link>

        <div className="flex items-center gap-4">
          {loc.pathname === "/" && (
            <button
              data-testid="nav-start-btn"
              onClick={() => navigate("/assessment")}
              className="hidden sm:inline-flex text-sm font-semibold text-navy hover:text-gold transition-colors duration-300"
            >
              {tr(lang, UI.start)}
            </button>
          )}
          <div className="flex items-center rounded-sm border border-border overflow-hidden text-xs font-bold">
            {["en", "tr", "es"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                className={`px-3 py-1.5 transition-colors duration-300 ${lang === l ? "bg-navy text-white" : "bg-transparent text-muted-foreground hover:text-navy"}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
